import * as React from "react";
import { List, Datagrid, TextField, DateField, Edit, SimpleForm, TextInput, Create, BooleanInput } from 'react-admin';

const CompanyTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

export const CompanyList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="registered_address_1" label="Address" />
            <TextField source="registered_address_city" label="City" />
            <TextField source="registered_address_country" label="Country" />
            <DateField source="created_at" />
            <TextField source="productions.length" label="Productions" />
        </Datagrid>
    </List>
);

export const CompanyEdit = props => (
    <Edit title={<CompanyTitle />} {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="registration_number" label="Company Registration Number" />
            <TextInput source="registered_address_1" label="Registered Address Line 1" />
            <TextInput source="registered_address_2" label="Registered Address Line 2" />
            <TextInput source="registered_address_city" label="City" />
            <TextInput source="registered_address_county" label="County" />
            <TextInput source="registered_address_postcode" label="Postcode" />
            <TextInput source="registered_address_country" label="Country" />
        </SimpleForm>
    </Edit>
);

export const CompanyCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="registration_number" label="Company Registration Number" />
            <TextInput source="registered_address_1" label="Registered Address Line 1" />
            <TextInput source="registered_address_2" label="Registered Address Line 2" />
            <TextInput source="registered_address_city" label="City" />
            <TextInput source="registered_address_county" label="County" />
            <TextInput source="registered_address_postcode" label="Postcode" />
            <TextInput source="registered_address_country" label="Country" />
        </SimpleForm>
    </Create>
);